import { render, staticRenderFns } from "./DeleteBuilding.vue?vue&type=template&id=450df00c&scoped=true&"
import script from "./DeleteBuilding.vue?vue&type=script&lang=js&"
export * from "./DeleteBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450df00c",
  null
  
)

export default component.exports